export const COLORS = {
  primary: '#3d1690',
  primaryDisabled: '#ede8fa',
  text: '#2e2e2e',
  textSecondary: '#737373',
  neutral50: '#8A8A8A',
  neutral80: '#474747',
  neutral100: '#2A2A2A',
  border: '#e2e2e2',
  borderHover: '#3d1690',
  borderDashed: '#b0b0b0',
  background: '#fff',
  backgroundWithBlur: 'rgb(255 255 255 / 92%)',
  backgroundSecondary: '#f7f7f7',
  backgroundOverlay: 'rgba(0, 0, 0, 0.5)',
  backgroundOverlayDark: 'rgba(0, 0, 0, 0.7)',
  success: '#3d1690',
  white: '#fff',
  shadow: 'rgba(0, 0, 0, 0.18)',
} as const;

export const FONT_FAMILIES = {
  primary: 'Plus Jakarta Sans',
} as const;

export const FONT_SIZES = {
  xs: '12px',
  sm: '14px',
  md: '15px',
  base: '16px',
  lg: '18px',
  xl: '20px',
  '2xl': '24px',
  '3xl': '32px',
} as const;

export const FONT_WEIGHTS = {
  normal: 400,
  medium: 500,
  semibold: 600,
} as const;

export const BORDER_RADIUS = {
  sm: '8px',
  md: '16px',
  lg: '20px',
  xl: '30px',
  full: '50%',
} as const;

export const SPACING = {
  xs: '4px',
  sm: '8px',
  md: '12px',
  lg: '16px',
  xl: '24px',
  '2xl': '32px',
  '3xl': '60px',
} as const;

export const Z_INDEX = {
  modal: 2000,
  confirmation: 2001,
  mobileModal: 999999,
} as const;

export const TRANSITIONS = {
  border: 'border 0.2s',
  background: 'background 0.2s',
  opacity: 'opacity 0.2s',
} as const;

export const FORM_LIMITS = {
  maxImages: 5,
  maxTitleLength: 200,
  maxContentLength: 5000,
  maxNicknameLength: 25,
  minNicknameLength: 4,
} as const;

export const BREAKPOINTS = {
  mobile: '1024px',
} as const;
